var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visit-page pb-3 mt-5 mb-5"},[_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.page.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }